import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, ButtonGroup, Typography, Box, Fab, Badge, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { formatDateTime, isColorDark, obtenerFechaHoraSQL } from '../../utils/utils';
import { actualizarTarea, eliminarTarea, updateTarea } from '../../services/apis';
import InfoIcon from '@mui/icons-material/Info';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import AutorenewIcon from '@mui/icons-material/Autorenew';

import CallIcon from '@mui/icons-material/Call';
import { actualizarTareaTaller } from '../../services/apis';
import { advertenciaConfirmar, advertenciaEliminar, solicitarValor } from '../../utils/componentes-utiles/advertencias';
import { FormEditarTarea } from '../proyectos/tareas/FormEditarTareay';
import { TareaDialog } from '../proyectos/tareas/TareaDialog';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ConstructionIcon from '@mui/icons-material/Construction';
import EuroIcon from '@mui/icons-material/Euro';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import SavingsIcon from '@mui/icons-material/Savings';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CreateIcon from '@mui/icons-material/Create';
import { FormEditarTareaTaller } from './FormEditarTareaTaller';
import Swal from 'sweetalert2';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { TicketTaller } from './TicketTaller';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { TareaTallerDialog } from './TareaTallerDialog';

export const TareaTallerCard = ({ tarea, opciones, estados, cargarTareas, opclientes, opTrabajadores }) => {

    const [tareaInfo, setTareaInfo] = useState(tarea);
    const [tareaEditar, setTareaEditar] = React.useState(false);
    const [open, setOpen] = useState(false);
    const [backgroundCard, setBackgroundCArd] = useState(estados.find(estado => estado.id === tarea.id_estado).color);
    const [textColor, setTextColor] = useState(isColorDark(tareaInfo.estado_color) ? '#FFFFFF' : '#000000');
    const [imprimir, setImprimir] = useState(false);

    //cambiar dinamicamente el color del fondo de la tarjeta
    useEffect(() => {
        setTextColor(isColorDark(estados.find(estado => estado.id == tareaInfo.id_estado).color) ? '#FFFFFF' : '#000000');
        setBackgroundCArd(estados.find(estado => estado.id == tareaInfo.id_estado).color);
    }, [tareaInfo.id_estado]);

    useEffect(() => {
        setTareaInfo(tarea);
        // // Mantener el diálogo abierto si el ID no ha cambiado
        // if (open !== null && open === tarea.id) {
        //     setOpen(tarea.id);
        // }
    }, [tarea]);

    const iconMapping = {
        DoneAllIcon: <DoneAllIcon />,
        PlayArrowIcon: <PlayArrowIcon />,
        PauseIcon: <PauseIcon />,
        EditIcon: <EditIcon />,
        DeleteForeverIcon: <DeleteForeverIcon />,
        FactCheckIcon: <FactCheckIcon />,
        CallIcon: <CallIcon />,
        ContentPasteSearchIcon: <ContentPasteSearchIcon />,
        ShoppingCartIcon: <ShoppingCartIcon />,
        ConstructionIcon: <ConstructionIcon />,
        EuroIcon: <EuroIcon />,
        PendingActionsIcon: <PendingActionsIcon />,
        SavingsIcon: <SavingsIcon />,
        TaskAltIcon: <TaskAltIcon />,
        LocalPrintshopIcon: <LocalPrintshopIcon />,
        CreateIcon: <CreateIcon />,




    };
    const handleEvent = (opcionId) => {
        switch (opcionId) {

            case 0:

                if (tareaInfo.id_estado == 7 || tareaInfo.id_estado == 6) {
                    (async () => {
                        const confirmado = await advertenciaConfirmar("¿Restaurar Parte?", ("Esta acción cambiará el estado a En Revisión el parte ID: " + tareaInfo.id));
                        if (confirmado) {
                            handleOnChange({ id_estado: 0 });
                        }
                    })();
                    break;
                } else {
                    handleOnChange({ id_estado: 0 });
                    break;
                }

            case 1:
                handleOnChange({ id_estado: 1 })
                break;
            case 2:

                (async () => {
                    const confirmado = await solicitarValor("¿Presupuestar?", ("Presupuesto del parte ID: " + tareaInfo.id), 'Introduce el valor en €', tarea.presupuesto, tarea.iva, tarea.comentario_presupuesto);
                    if (confirmado) {
                        handleOnChange({
                            presupuesto: confirmado.precio,
                            iva: confirmado.aplicarIVA,
                            comentario_presupuesto: confirmado.comentario,
                            id_estado: 2
                        });
                    }
                })();
                break;
            case 3:
                // handleOnChange({ id_estado: 3 })

                (async () => {
                    const confirmado = await solicitarValor(" ¿Reparado?", ("Presupuesto del parte ID: " + tareaInfo.id), 'Introduce el valor en €', tarea.presupuesto, tarea.iva, tarea.comentario_presupuesto);
                    if (confirmado) {
                        handleOnChange({
                            presupuesto: confirmado.precio,
                            iva: confirmado.aplicarIVA,
                            comentario_presupuesto: confirmado.comentario,
                            id_estado: 3
                        });
                    }
                })();
                break;
            case 4:
                handleOnChange({ id_estado: 4 })
                break;
            case 5:
                handleOnChange({ id_estado: 5 })

                break;
            case 7:
                (async () => {
                    const confirmado = await advertenciaConfirmar("¿Marcar como pagado?", ("Esta acción cambiará el estado a Terminado el parte ID: " + tareaInfo.id));
                    if (confirmado) {
                        handleOnChange({ id_estado: 7 });
                    }
                })();
                break;
            case 50:
                setTareaEditar(true);
                break;
            case 51:
                (async () => {
                    const confirmado = await advertenciaConfirmar("¿DESCARTAR?", ("Esta acción descartará el parte ID: " + tareaInfo.id));
                    if (confirmado) {
                        handleOnChange({ id_estado: 6 });
                    }
                })();

                break;
            case 53:
                setImprimir(!imprimir);
            case 90:
                break;
            default:
                console.log("Lógica para una opción desconocida");
                break;
        }
    }


    const handleOnChange = (data) => {
        // Crear una copia del objeto tarea
        let temp = { ...tareaInfo };

        // Aplicar todos los cambios en `data`
        Object.entries(data).forEach(([key, value]) => {
            if (temp.hasOwnProperty(key)) {
                temp[key] = value;
            }
        });

        // Actualizar el estado con todos los cambios en una sola llamada
        actualizarTareaEstado(temp);
    };

    const actualizarTareaEstado = (data) => {
        let temp = { ...data };
        temp.fechaActual = obtenerFechaHoraSQL();
        actualizarTareaTaller(temp).then(() => {
            cargarTareas(); // Se ejecuta después de que actualizarTarea se completa
        })
    }

    const precioTotalExtras = (extras) => {
        let total = 0;

        extras.forEach(ext => {
            total = total + ext.precio;
        });
        return total;
    }


    const eliminarTareaF = async (id) => {
        const titulo = "Eliminar Tarea " + tarea.id;
        const texto = "Vas a eliminar permanentemente esta tarea";

        // Asegúrate de esperar el resultado de advertenciaEliminar
        const confirmado = await advertenciaEliminar(titulo, texto);
        if (confirmado) {
            try {
                const response = await eliminarTarea(id)
                if (response.success == true) {
                    cargarTareas();
                }
            }
            catch (error) {
                console.error("Error al eliminar la tarea:", error);

            }
        }

    };

    const getContraryColor = (hexColor) => {
        // Validar que el color sea un string
        if (typeof hexColor !== 'string') {
            throw new Error('El color debe ser una cadena de texto');
        }

        // Limpiar el color (remover # si existe)
        let cleanHex = hexColor.replace('#', '');

        // Validar formato
        if (!/^[0-9A-Fa-f]{6}$/.test(cleanHex) && !/^[0-9A-Fa-f]{3}$/.test(cleanHex)) {
            throw new Error('Formato de color hexadecimal inválido');
        }

        // Expandir formato corto (3 dígitos) a formato largo (6 dígitos)
        if (cleanHex.length === 3) {
            cleanHex = cleanHex.split('').map(char => char + char).join('');
        }

        // Convertir a RGB
        const r = parseInt(cleanHex.substring(0, 2), 16);
        const g = parseInt(cleanHex.substring(2, 4), 16);
        const b = parseInt(cleanHex.substring(4, 6), 16);

        // Calcular el color contrario (invertir cada componente)
        const contraryR = 255 - r;
        const contraryG = 255 - g;
        const contraryB = 255 - b;

        // Ajustar brillo - hacerlo más vibrante
        const adjustBrightness = (value) => {
            // Aumentar el contraste para hacerlo más brillante
            if (value < 128) {
                return Math.min(255, value + 12); // Aumentar valores oscuros
            } else {
                return Math.min(255, value + 128); // Aumentar ligeramente valores claros
            }
        };

        // Aplicar ajuste de brillo
        const brightR = adjustBrightness(contraryR);
        const brightG = adjustBrightness(contraryG);
        const brightB = adjustBrightness(contraryB);

        // Convertir a hexadecimal
        const brightHexR = Math.round(brightR).toString(16).padStart(2, '0');
        const brightHexG = Math.round(brightG).toString(16).padStart(2, '0');
        const brightHexB = Math.round(brightB).toString(16).padStart(2, '0');

        return `#${brightHexR}${brightHexG}${brightHexB}`.toUpperCase();
    };

    return (
        <Grid
            container
            direction="column"
            justifyContent="start"
            alignItems="center"
            xs={12}
            // sm={6} md={4} xl={2}
            fontWeight={500}
            padding={2}
            style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor,
                // maxHeight: '60vh',
                // minHeight: '60vh'
            }}
            className="tarea-card fade-in2"
        >
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                xs={12}
            >
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    xs={11.5}
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                    >
                        <Typography variant="h5" gutterBottom>
                            Parte: {tareaInfo.id}
                        </Typography>


                        <Grid
                            container
                            direction="row"
                            justifyContent="end"
                            alignItems="center"
                            xs={6}
                            gap={1}
                        >
                            <Tooltip title="Parte rescatado" placement="top" arrow>
                                <AutorenewIcon sx={{ fontSize: 30, marginBottom: 2, display: tareaInfo.rescatado === 1 ? 'flex' : 'none' }} />
                            </Tooltip>

                            {tareaInfo.telefono && (
                                <Grid
                                    item
                                    xs={'auto'}
                                    onClick={() => window.open("https://wa.me/34" + tareaInfo.telefono, "_blank")}
                                    className='pointer'
                                >
                                    <WhatsAppIcon sx={{ fontSize: 30, marginBottom: 2 }} />
                                    {/* --------------------------------------------------------ARREGLAR ESTOS ICONOS------------------------------------------- */}
                                </Grid>
                            )}
                            <Grid item xs={'auto'} onClick={() => setOpen(true)} className='pointer'>
                                <Badge badgeContent={tareaInfo.comentarios.total_comentarios} color="primary">
                                    <InfoIcon sx={{ fontSize: 30, marginBottom: 2 }} />
                                </Badge>

                            </Grid>
                        </Grid>

                    </Grid>
                    <Grid container xs={12} textAlign={'left'} justifyContent={'space-between'} >
                        <Grid item xs={6} textAlign={'left'} alignItems={'center'}>
                            <Typography variant="p" gutterBottom
                                sx={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 1, // Limita el número de líneas
                                    WebkitBoxOrient: 'vertical',
                                    maxWidth: '100%',
                                    fontWeight: 700,
                                    fontSize: '1em',
                                }}
                            >
                                {tareaInfo.nombre_cliente}
                            </Typography>
                        </Grid>
                        <Grid item xs={6} style={{ textAlign: 'right', marginTop: '-0.2em' }}>
                            <Typography variant="subtitle2" gutterBottom>
                                {formatDateTime(tareaInfo.fecha)}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        xs={12}
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        sx={{
                            marginBottom: '1em',
                            minHeight: '7vh',
                            maxHeight: '7vh',
                        }}
                    >

                        <Grid item xs={12} textAlign={'left'} >
                            <Typography variant="p"
                                sx={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 1, // Limita el número de líneas
                                    WebkitBoxOrient: 'vertical',
                                    maxWidth: '100%',
                                    fontWeight: 500,
                                    fontSize: '0.8em',
                                }}
                            >
                                {tareaInfo.cliente}
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            xs={12}
                            onClick={() => setOpen(true)}
                            sx={{ display: tareaInfo.presupuesto === null || tareaInfo.presupuesto === "null" ? 'none' : 'flex' }}
                        >
                            <Typography variant="h5"
                                sx={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 1, // Limita el número de líneas
                                    WebkitBoxOrient: 'vertical',
                                    maxWidth: '100%',

                                }}
                            >
                                {/* {tareaInfo.presupuesto}{tareaInfo.presupuesto ? "€" : ""} */}
                                {(parseInt(tarea.presupuesto) + precioTotalExtras(tarea.extras))}€

                            </Typography>

                            {tareaInfo.presupuesto && (
                                tareaInfo.iva === 1
                                    ? <Typography variant="h6">
                                        IVA incluido
                                    </Typography>
                                    : <Typography variant="h4" sx={{ fontWeight: 800, color: getContraryColor(backgroundCard) }}>
                                        Más IVA
                                    </Typography>
                            )}

                            {tareaInfo.comentario_presupuesto != '' && (
                                <Grid container xs={12} onClick={() => setOpen(true)} textAlign='right' className='pointer' justifyContent={'start'}>
                                    <Typography variant="body1"
                                        sx={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 1, // Limita el número de líneas
                                            WebkitBoxOrient: 'vertical',
                                            maxWidth: '100%',
                                            fontWeight: 500,
                                            fontSize: '0.8em',
                                        }}
                                    >
                                        {tareaInfo.comentario_presupuesto}
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>



                    </Grid>
                    <Grid
                        container
                        xs={12}
                        textAlign={'left'}
                        justifyContent={'space-between'}
                        alignItems={'center'}
                    >
                        <Grid item xs={12} style={{ textAlign: 'left' }}>
                            <Typography variant="caption" sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 1, // Limita el número de líneas
                                WebkitBoxOrient: 'vertical',
                                maxWidth: '100%',
                                fontWeight: 800,
                                fontSize: '0.8em',
                            }}>
                                {tareaInfo.telefono}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} style={{ textAlign: 'left' }}>
                            <Typography variant="caption" gutterBottom>
                                {tareaInfo.correo}
                            </Typography>
                        </Grid>
                    </Grid>
                    {/* <Grid item xs={12} style={{ textAlign: 'left', marginTop: '-0.5em' }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Horas empleadas: {tareaInfo.horas + ":" + tareaInfo.minutos + " HH:mm"}
                        </Typography>
                    </Grid> */}

                </Grid>
            </Grid>

            {/* <div className="separador"></div> */}

            <Grid
                container
                direction="column"
                justifyContent="start"
                alignItems="start"
                xs={11.5}
                sx={{
                    minHeight: '11vh', // Ajusta este valor a la altura fija que deseas
                    maxHeight: '11vh',
                    overflow: 'hidden',
                }}

            >
                <Typography variant="p" gutterBottom style={{ fontWeight: 750, minHeight: '1vh' }} textAlign={'left'}>
                    {tareaInfo.asunto}
                </Typography>

                <Grid container xs={12} justifyContent="start" alignItems="start">
                    <Box
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2, // Limita el número de líneas
                            WebkitBoxOrient: 'vertical',
                            // minHeight: '4vh', // Ajusta este valor a la altura fija que deseas
                            // maxHeight: '4vh',
                        }}
                    >
                        {/* <Typography variant="body1" gutterBottom textAlign={'left'}>
                            {tareaInfo.descripcion}
                        </Typography> */}
                    </Box>
                </Grid>
                <Grid container xs={12} justifyContent="start" alignItems="start">
                    <Box
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2, // Limita el número de líneas
                            WebkitBoxOrient: 'vertical',
                            // maxWidth: '100%',
                            // minHeight: '4vh', // Ajusta este valor a la altura fija que deseas
                            // maxHeight: '4vh',
                        }}
                    >
                        <Typography variant="body1" gutterBottom textAlign={'left'}>
                            {tareaInfo.dispositivo ? "Dispositivo: " + tareaInfo.dispositivo : ""}
                        </Typography>
                    </Box>
                </Grid>



            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="start"
                xs={11.5}
            // style={{
            //     minHeight: '5vh',
            //     backgroundColor: 'red'
            // }}
            >
                <Grid
                    container
                    direction="row"
                    justifyContent="start"
                    alignItems="start"
                    xs={5}
                >
                    {tareaInfo.trabajadores.length > 0 && (
                        <Grid container xs={12} direction="row" justifyContent="start" alignItems="start">
                            <Grid container xs={12} direction="row" justifyContent="start" alignItems="start" >
                                <Typography variant="subtitle1" gutterBottom>
                                    Asignado a:&nbsp;
                                </Typography>
                            </Grid>

                            {(tarea.trabajadores.slice(0, 3)).map((trabajador, index) => (
                                <Grid item xs={12} textAlign={'left'}>
                                    <Typography variant="caption" gutterBottom key={index} sx={{ fontWeight: 600 }}>
                                        {trabajador.label}&nbsp;
                                    </Typography>
                                </Grid>
                            ))}
                            <>
                                {tareaInfo.trabajadores.length > 3 && (
                                    <Typography variant="caption" gutterBottom sx={{ fontWeight: 600 }}>
                                        y mas...
                                    </Typography>
                                )}
                            </>
                        </Grid>
                    )}
                    {tareaInfo.trabajadores.length == 0 && (
                        // <Grid container xs={12} justifyContent="start" alignItems="start"
                        // // className='descripcion-titulo'
                        // >
                        //     <Typography variant="subtitle1" gutterBottom>
                        //         Asignado a: &nbsp;
                        //     </Typography>
                        //     <Typography variant="caption" gutterBottom >
                        //         Sin Asignar
                        //     </Typography>
                        // </Grid>
                        <></>
                    )}


                </Grid>

                <Grid
                    container
                    direction="row"
                    justifyContent="end"
                    alignItems="start"
                    xs={5}
                // style={{
                //     minHeight: '13vh',
                //     maxHeight: '13vh'
                // }}
                >
                    {tareaInfo.usuarios_con_tiempo.length > 0 && (
                        <Grid container xs={12} justifyContent="end" alignItems="start">
                            <Typography variant="subtitle1" gutterBottom style={{ marginBottom: '-0.2em' }} >
                                En curso por:&nbsp;
                            </Typography>
                            {(tarea.usuarios_con_tiempo.slice(0, 3)).map((trabajador, index) => (
                                <Grid container xs={12} justifyContent="end" alignItems="end" >
                                    <Typography variant="caption" gutterBottom key={index} sx={{ fontWeight: 600 }}>
                                        {trabajador.label}&nbsp;
                                    </Typography>
                                </Grid>

                            ))}
                            <>
                                {tareaInfo.usuarios_con_tiempo.length > 3 && (
                                    <Typography variant="caption" gutterBottom sx={{ fontWeight: 600 }}>
                                        y mas...
                                    </Typography>
                                )}
                            </>
                        </Grid>
                    )}
                    {tareaInfo.usuarios_con_tiempo.length == 0 && (
                        // <Grid container xs={12} justifyContent="end" alignItems="end" >
                        //     <Typography variant="subtitle1" gutterBottom textAlign={'right'}>
                        //         En curso por:&nbsp;
                        //     </Typography>
                        //     <Typography variant="caption" gutterBottom textAlign={'right'}>
                        //         Sin Trabajadores En Curso
                        //     </Typography>
                        // </Grid>
                        <></>
                    )}

                </Grid>

            </Grid>


            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                xs={11.5}
                gap={1}
                style={{ marginTop: '0em' }}
            >
                {opciones.map((opcion, index) => (
                    <Grid container xs={2} key={index} alignItems='center' justifyContent='center' >
                        <Fab
                            fullWidth
                            size="small"
                            variant='contained'
                            className='button-default'
                            color="primary"
                            key={index}
                            onClick={() => handleEvent(opcion.id_estado)}
                            title={opcion.nombre}

                            disabled={
                                (tarea.id_estado == 0 && (opcion.id_estado == 0 || opcion.id_estado == 2 || opcion.id_estado == 3 || opcion.id_estado == 4 || opcion.id_estado == 5 || opcion.id_estado == 6 || opcion.id_estado == 7)) ||
                                (tarea.id_estado == 1 && (opcion.id_estado == 1 || opcion.id_estado == 4 || opcion.id_estado == 5 || opcion.id_estado == 6 || opcion.id_estado == 7)) ||
                                (tarea.id_estado == 2 && (opcion.id_estado == 0 || opcion.id_estado == 2 || opcion.id_estado == 4 || opcion.id_estado == 5 || opcion.id_estado == 6 || opcion.id_estado == 7)) ||
                                (tarea.id_estado == 3 && (opcion.id_estado == 0 || opcion.id_estado == 1 || opcion.id_estado == 3 || opcion.id_estado == 5 || opcion.id_estado == 6 || opcion.id_estado == 7)) ||
                                (tarea.id_estado == 4 && (opcion.id_estado == 0 || opcion.id_estado == 1 || opcion.id_estado == 2 || opcion.id_estado == 4 || opcion.id_estado == 6 || opcion.id_estado == 7)) ||
                                (tarea.id_estado == 5 && (opcion.id_estado == 0 || opcion.id_estado == 1 || opcion.id_estado == 2 || opcion.id_estado == 3 || opcion.id_estado == 5)) ||
                                (tarea.id_estado == 6 && (opcion.id_estado == 1 || opcion.id_estado == 2 || opcion.id_estado == 3 || opcion.id_estado == 4 || opcion.id_estado == 5 || opcion.id_estado == 6 || opcion.id_estado == 7 || opcion.id_estado == 51 || opcion.id_estado == 50)) ||
                                (tarea.id_estado == 7 && (opcion.id_estado == 1 || opcion.id_estado == 2 || opcion.id_estado == 3 || opcion.id_estado == 4 || opcion.id_estado == 5 || opcion.id_estado == 6 || opcion.id_estado == 7 || opcion.id_estado == 51 || opcion.id_estado == 50))

                            }>

                            {iconMapping[opcion.icono] && (
                                <>
                                    {iconMapping[opcion.icono]}&nbsp;
                                </>
                            )}
                        </Fab>
                    </Grid>
                ))}
            </Grid>





            {/* //desplegable */}
            {
                tareaEditar == true && (
                    <FormEditarTareaTaller open={tareaEditar} setOpen={setTareaEditar} cargarTareas={cargarTareas} tareaInfo={tareaInfo} setTareaInfo={setTareaInfo}
                        opclientes={opclientes} opTrabajadores={opTrabajadores} trabajadores={tarea.trabajadores} estados={estados} />
                )
            }
            {
                open == true && (

                    <TareaTallerDialog open={open} setOpen={setOpen} tareaInfo={tareaInfo} setTareaInfo={setTareaInfo} opciones={opciones} handleEvent={handleEvent} backgroundCard={backgroundCard} textColor={textColor} />
                )
            }
            {
                imprimir == true && (
                    <>
                        <TicketTaller tareaInfo={tareaInfo} > </TicketTaller>
                    </>
                )

            }
        </Grid >


    )
}
